function d(e) {
  return new Worker(
    "" + new URL("../../../assets/uploadWorker-YqrAi5ug.js", import.meta.url).href,
    {
      type: "module",
      name: e?.name
    }
  );
}
const i = (e) => new Promise((t, n) => {
  const o = new d({
    name: e
  }), r = 2e4, s = setTimeout(() => {
    n(`Upload worker did not respond within ${r / 1e3} seconds`);
  }, r);
  o.addEventListener("message", (a) => {
    a.data === "hello" && (clearTimeout(s), t(o));
  });
});
export {
  i as default
};
//# sourceMappingURL=uploadWorkerPromise.js.map
